import { ToastProps } from '@trackman/web-shared-components';
import { create } from 'zustand';
import shortid from 'shortid';

type Store = {
  duration: number;
  maxToasts: number;
  toasts: ToastProps[];
  handleOnClose: (id: string) => void;
  addToast: (header: string, message: string, severity: 'info' | 'success' | 'error') => void;
};

export const useNotificationsStore = create<Store>()((set, get) => ({
  duration: 5000,
  maxToasts: 30,
  toasts: [],
  handleOnClose: (id: string) => set((state) => ({ toasts: state.toasts.filter((toast: ToastProps) => toast.id !== id) })),
  addToast: (header: string, message: string, severity: 'info' | 'success' | 'error') => {
    const id = shortid.generate();

    set((state) => {
      const toastsCopy = structuredClone(state.toasts);
      if (toastsCopy.length >= get().maxToasts) toastsCopy.shift();

      toastsCopy.push({
        severity: severity,
        header: header,
        message: message,
        id: id,
      });

      return { toasts: toastsCopy };
    });

    new Promise((resolve) => {
      setTimeout(() => {
        resolve(id);
        set((state) => ({ toasts: state.toasts.filter((toast: ToastProps) => toast.id !== id) }));
      }, get().duration);
    });
  },
}));
